import * as React from 'react';

import { formatDate } from '../../utils/formatters';

import * as styles from './GallerySectionLayout.css';
import { GallerySectionGridLayout } from './components/GallerySectionGridLayout';

export interface IGallarySectionLayoutProps {
  newbuildingName: string;
  date: string;
  children: React.ReactNode[];
}

export const GallerySectionLayout: React.FC<IGallarySectionLayoutProps> = props => {
  const { children, date, newbuildingName } = props;

  return (
    <article className={styles['container']} key={date} data-testid="GallerySectionLayout">
      <header className={styles['date']}>{formatDate(date)}</header>
      <h1 className={styles['title']}>
        Ход строительства ЖК «{newbuildingName}» от {formatDate(date)}
      </h1>
      <GallerySectionGridLayout>{children}</GallerySectionGridLayout>
    </article>
  );
};
